const home = {
  "hero.title": "Engineering the Future of",
  "hero.titleHighlight": "Enterprise Technology",
  "hero.subtitle": "We build enterprise-grade CRM, ERP, AI automation, and custom software solutions that drive operational excellence and accelerate digital transformation for businesses worldwide.",
  "hero.ctaPrimary": "Start a Project",
  "hero.ctaSecondary": "Our Services",
  "nav.home": "Home",
  "nav.services": "Services",
  "nav.solutions": "Solutions",
  "nav.about": "About",
  "nav.contact": "Contact",
  "nav.cta": "Get in Touch",
  "services.title": "What We Build",
  "services.subtitle": "End-to-end technology solutions engineered for performance, scalability, and real business impact.",
  "ai.title": "AI & Intelligent Automation",
  "ai.subtitle": "Production-ready artificial intelligence that automates workflows, extracts insights, and creates competitive advantage.",
  "why.title": "Why Industry Leaders Choose Emporris",
  "why.subtitle": "A track record of delivering complex technology projects on time, within budget, and above expectations.",
  "testimonials.title": "Trusted by Forward-Thinking Teams",
  "testimonials.subtitle": "Hear from the technology leaders and executives who rely on our solutions every day.",
  "contact.title": "Let's Build Something Exceptional",
  "contact.subtitle": "Tell us about your project. We respond within one business day with a tailored approach.",
  "contact.name": "Full Name",
  "contact.email": "Work Email",
  "contact.company": "Company",
  "contact.phone": "Phone Number",
  "contact.message": "Tell us about your project",
  "contact.submit": "Send Inquiry",
  "footer.about": "Emporris is an enterprise technology company delivering CRM, ERP, AI, and custom software solutions from Noida, India to clients worldwide.",
  "footer.quickLinks": "Navigate",
  "footer.services": "Capabilities",
  "footer.contact": "Office",
  "footer.copyright": "Emporris Technologies Pvt. Ltd. All rights reserved.",
  "footer.address": "C Tower, 10th Floor, Noida Sector 62, Uttar Pradesh 201309, India",
  "footer.phone": "+91 6262623452",
  "footer.email": "hello@emporris.com",
};

export default home;